import { inView, animate } from 'motion';

inView('.block-line-block', (element) => {
	const target = element.target as HTMLElement;
	setTimeout(() => {
		target.style.setProperty('--line-width', '100%');
	}, 400);
});
